<template>
  <v-dialog
    v-model="isOpen"
    max-width="700"
    @input="handleClose"
  >
    <v-card>
      <v-card-title class="headline pb-10">
        Вы точно хотите удалить выбранный сервер {{currentServer.name}}?
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close()">Закрыть</v-btn>
        <v-btn text color="primary" @click="deleteServer()">Удалить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import OverlayLoader from '@/app/shared/components/app-loader/Loader';

export default {
  name: 'confirmDeletionModal',
  components: {
    OverlayLoader,
  },
  data() {
    return {
    };
  },
  computed: {
    isOpen: {
      get(){
        return this.$store.getters.IS_CONFIRM_DELETION_SERVER_MODAL_OPENED;
      },
      set(){
        this.$store.dispatch('CONFIRM_DELETION_SERVER_MODAL', false);
      }
    },
    currentServer: {
      get(){
        return this.$store.getters.GET_CURRENT_SERVER;
      },
      set(value){
        this.$store.commit("SET_CURRENT_SERVER", value);
      }
    },
  },
  methods: {
    close() {
      this.$store.dispatch('CONFIRM_DELETION_SERVER_MODAL', false);
    },
    deleteServer(){
      this.$store.dispatch('DELETE_SERVER', this.currentServer.id)
        .then(() => {
          this.$toast.success('Сервер был удален');
          this.$store.dispatch("GET_SERVERS");
          this.$store.dispatch('CONFIRM_DELETION_SERVER_MODAL', false);
        })
        .catch(() => {
          this.$toast.error('Неизвестная ошибка');
        });
    },
    handleClose(isOpen) {
      if (!isOpen) {
        this.close();
      }
    }
  },
};
</script>
